import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse} from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IDocument } from '../interfaces/idocument';


@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  private _taxpayerDocument: Array<IDocument>;
  private BASE_URL:string = window["cfgApiBaseUrl"];
  private FILE_UPLOAD_URL:string = this.BASE_URL+"file/upload";
  private PDF_FILE_URL:string = this.BASE_URL+"file/pdf=";
  private VALIDATE_TIN_URL:string = this.BASE_URL+"file/validate?tin=";
  private FILE_DOWNLOAD_URL:string = this.BASE_URL+"file/download?tin=";
  
  constructor(private http:HttpClient) { }

  public get taxpayerDocument(): Array<IDocument> {
    return this._taxpayerDocument;
  }

  postFile(tin: string, fileToUpload: File) {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('tin', tin)
    return this.http.post(this.FILE_UPLOAD_URL, formData,{
      reportProgress: true,
      observe: 'events'
    }).pipe(catchError(this.errorHandler));
     
}
postFilename(name:string){
  return this.http.get(this.PDF_FILE_URL+name).pipe(catchError(this.errorHandler));
}

validateTin(tin:string){
  return this.http.get<any>(this.VALIDATE_TIN_URL+tin).pipe(catchError(this.errorHandler));
}

getTaxpayerDocument(tin:string){
  return this.http.get<any>(this.FILE_DOWNLOAD_URL+tin).pipe(
    map( res =>{
      this._taxpayerDocument = res;
      return true;
    }),
    catchError(this.errorHandler));
}

errorHandler(error : HttpErrorResponse){
   return throwError(error.message || "Server Error");
 }

}
